import localforage from 'localforage'
import MD5 from 'crypto-js/md5'

class VersionDB {
  constructor (config) {
    this.db = localforage.createInstance({
      name: config.name,
      storeName: 'cache-versions',
    })
  }

  get (key) {
    return this.db.getItem(key)
  }

  set (key, data) {
    return this.db.setItem(key, data)
  }

  makeKey (key, data) {
    return key + '_' + MD5(JSON.stringify(data)).toString()
  }

  remove (keys) {
    if (keys.constructor !== Array) {
      keys = [keys]
    }
    keys.forEach((key) => {
      this.db.removeItem(key)
    })
  }
}

export { VersionDB }
export default VersionDB



// WEBPACK FOOTER //
// ./src/views/question-editor/components/question-cache-box/db/version-db.js